import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileWithErrorIcon = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 60 68",
  ...props,
  children: [/*#__PURE__*/_jsx("path", {
    stroke: "currentColor",
    strokeMiterlimit: 333.33,
    strokeWidth: 5,
    d: "M41.886 55.868v2.783c-.017 3.02-2.418 5.498-5.438 5.591H8.382a5.624 5.624 0 0 1-5.59-5.591V8.382a5.623 5.623 0 0 1 5.59-5.59H36.44a5.623 5.623 0 0 1 5.59 5.59v2.927"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#4B4D59",
    d: "M27.93 8.227H16.756A2.928 2.928 0 0 1 13.973 5.3h16.765c0 1.57-1.239 2.86-2.808 2.927Z"
  }), /*#__PURE__*/_jsx("mask", {
    id: "prefix__a",
    width: 37,
    height: 38,
    x: 23,
    y: 14,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M59.992 14.864h-36.5V51.38h36.5V14.864Z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#prefix__a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#DC3628",
      d: "M41.75 51.363c9.986 0 18.25-8.28 18.25-18.25 0-9.968-8.28-18.249-18.266-18.249-9.986 0-18.233 8.264-18.233 18.25s8.28 18.25 18.25 18.25Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M41.75 36.448c-.933 0-1.45-.518-1.467-1.468l-.23-9.748c-.016-.95.68-1.63 1.68-1.63 1.002 0 1.715.697 1.698 1.647l-.255 9.731c-.017.967-.535 1.468-1.434 1.468h.009Zm0 5.998c-1.077 0-2.002-.857-2.002-1.917s.917-1.935 2.003-1.935 2.002.857 2.002 1.935c0 1.077-.933 1.917-2.002 1.917Z"
    })]
  }), /*#__PURE__*/_jsx("path", {
    fill: "#4B4D59",
    d: "M23.306 57.93a2.757 2.757 0 1 0 0-5.515 2.757 2.757 0 0 0 0 5.515Z"
  })]
});
export default MobileWithErrorIcon;